module.exports = __webpack_public_path__ + "static/media/peabody.9c75f790.jpeg";